import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import Joi from "joi";
import {
  DialogComponent,
  Inputs,
  Spinner,
  AutocompleteComponent,
} from "../../../../Components";
import { MessageConfirmDialog } from "../../../../SharedComponents";
import { showError, showSuccess } from "../../../../Helper";
import {
  GetAllHubSpotListsAPI,
  ImportContactsAPI,
  CreateHubSpotListAPI,
  GetAllConvoloProjects,
  CreateConvoloProject,
  PullContactsToConvolo,
} from "../../../../Services";
import { ButtonBase } from "@material-ui/core";
const HubSpotIcon = () => (
  <svg width="91" height="36" viewBox="0 0 91 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 9.84735H3.63821V16.7937H10.2569V9.84735H13.3992V26.8986H10.2569V19.8063H3.63821V26.8986H0.5V9.84735Z" fill="#2153B1" />
    <path d="M23.3409 21.3448C23.3409 22.7721 22.1737 23.9337 20.7413 23.9337C19.3085 23.9337 18.1419 22.7721 18.1419 21.3448V14.0036H15.1658V21.3448C15.1658 24.4074 17.6671 26.8986 20.7413 26.8986C23.8148 26.8986 26.316 24.4074 26.316 21.3448V14.0036H23.3409V21.3448Z" fill="#2153B1" />
    <path d="M34.6242 14.0896C33.1479 14.0896 32.1174 14.5164 31.1223 15.4896V9.84735H28.1365V20.3041C28.1365 24.2181 30.9769 26.8986 34.168 26.8986C37.7157 26.8986 40.824 24.1703 40.824 20.4943C40.824 16.8648 37.9577 14.0896 34.6242 14.0896ZM34.6984 24.1466C32.6752 24.1466 31.1281 22.4632 31.1281 20.4943C31.1281 18.525 32.6752 16.841 34.6984 16.841C36.4127 16.841 37.9607 18.525 37.9607 20.4943C37.9607 22.4632 36.4127 24.1466 34.6984 24.1466Z" fill="#2153B1" />
    <path d="M45.8389 14.839C45.8389 13.3436 46.8389 12.8695 47.9338 12.8695C48.8152 12.8695 49.9815 13.5337 50.7427 14.3403L52.6945 12.0634C51.7191 10.7589 49.7434 9.8573 48.1243 9.8573C44.8861 9.8573 42.5528 11.7313 42.5528 14.839C42.5528 20.6028 49.6718 18.7758 49.6718 22.0025C49.6718 22.9977 48.696 23.8762 47.5776 23.8762C45.8151 23.8762 45.2435 23.0222 44.4343 22.1206L42.2673 24.3499C43.649 26.0342 45.3627 26.8886 47.4104 26.8886C50.4815 26.8886 52.9577 24.9909 52.9577 22.0255C52.9577 15.6213 45.8389 17.6141 45.8389 14.839Z" fill="#2153B1" />
    <path d="M60.8179 13.9225C57.6272 13.9225 54.7864 16.6014 54.7864 20.5163V31H57.772V25.3309C58.7673 26.3035 59.7973 26.731 61.2741 26.731C64.6074 26.731 67.4741 23.9561 67.4741 20.3266C67.4741 16.6501 64.3649 13.9225 60.8179 13.9225ZM61.3485 23.9799C59.3255 23.9799 57.7782 22.2942 57.7782 20.3266C57.7782 18.3574 59.3255 16.6734 61.3485 16.6734C63.0624 16.6734 64.6106 18.3574 64.6106 20.3266C64.6106 22.2942 63.0624 23.9799 61.3485 23.9799Z" fill="#2153B1" />
    <path d="M89.4517 24.1466C87.6906 24.1466 87.1907 23.3879 87.1907 22.2252V17.0782H89.9281V14.4693H87.1907V11.0295L84.168 12.3813V22.8657C84.168 25.5463 86.0243 26.8986 88.5706 26.8986C88.9516 26.8986 89.476 26.8741 89.762 26.8038L90.5001 24.1C90.1668 24.123 89.7861 24.1466 89.4517 24.1466Z" fill="#2153B1" />
    <path d="M81.5777 17.2298C81.0054 16.2487 80.2002 15.4621 79.1937 14.87C78.4415 14.4337 77.6615 14.1568 76.7825 14.0379V10.9204C77.6615 10.5486 78.207 9.72562 78.207 8.7655C78.207 7.45686 77.1536 6.39639 75.8412 6.39639C74.5277 6.39639 73.4559 7.45686 73.4559 8.7655C73.4559 9.72562 73.9699 10.5486 74.8488 10.9204V14.0393C74.1457 14.1405 73.4165 14.3589 72.7506 14.6945C71.3905 13.6654 66.9307 10.2892 64.3218 8.31732C64.3837 8.09507 64.4313 7.86598 64.4313 7.62429C64.4313 6.17484 63.2532 5 61.7978 5C60.3424 5 59.1648 6.17484 59.1648 7.62429C59.1648 9.07357 60.3436 10.2488 61.799 10.2488C62.2955 10.2488 62.7546 10.1041 63.1508 9.86625L63.7014 10.2824L71.2667 15.7131C70.8668 16.079 70.4943 16.4951 70.1964 16.962C69.5925 17.9139 69.2235 18.9613 69.2235 20.1037V20.3421C69.2235 21.144 69.3765 21.9011 69.637 22.6124C69.8664 23.2334 70.2018 23.7981 70.6172 24.3086L68.1064 26.8163C67.8837 26.7345 67.6497 26.6896 67.4055 26.6896C66.862 26.6896 66.3522 26.9012 65.9677 27.2835C65.5829 27.6669 65.3721 28.1761 65.3721 28.7179C65.3723 29.2596 65.5841 29.7688 65.9688 30.1518C66.3532 30.535 66.8642 30.7462 67.4081 30.7462C67.952 30.7462 68.4632 30.535 68.848 30.1518C69.232 29.7688 69.444 29.2595 69.444 28.7179C69.444 28.5083 69.4115 28.3037 69.3503 28.1093L71.9455 25.5234C72.3013 25.7682 72.6855 25.9744 73.0987 26.1521C73.9134 26.5031 74.8128 26.717 75.797 26.717H75.9774C77.0655 26.717 78.092 26.4623 79.0569 25.9414C80.0737 25.391 80.8695 24.6382 81.4707 23.6772C82.075 22.7136 82.4078 21.6489 82.4078 20.4776V20.4191C82.4078 19.2669 82.1401 18.2038 81.5777 17.2298ZM78.4068 22.6544C77.7024 23.4343 76.8927 23.9147 75.9774 23.9147H75.8266C75.3038 23.9147 74.7924 23.7708 74.2917 23.5089C73.7275 23.2206 73.2985 22.8094 72.9475 22.2887C72.5846 21.7777 72.3878 21.2197 72.3878 20.6281V20.4484C72.3878 19.8667 72.4997 19.3152 72.7821 18.7943C73.0839 18.225 73.4915 17.7822 74.0337 17.4302C74.566 17.0806 75.1345 16.9091 75.7677 16.9091H75.8266C76.4007 16.9091 76.9443 17.0219 77.4572 17.2834C77.9798 17.5622 78.4068 17.9432 78.7378 18.4442C79.0594 18.9455 79.2506 19.4861 79.3121 20.0751C79.3218 20.1976 79.3267 20.323 79.3267 20.4428C79.3267 21.2421 79.0202 21.9824 78.4068 22.6544Z" fill="#F8761F" />
  </svg>
);

const BrightCallIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    width="37.000000pt"
    height="36.000000pt"
    viewBox="0 0 37.000000 36.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,36.000000) scale(0.100000,-0.100000)"
      fill="#0074ff"
      stroke="none"
    >
      <path d="M93 325 c-75 -45 -102 -138 -64 -221 59 -130 253 -130 312 0 32 70 22 135 -29 189 -60 64 -145 76 -219 32z m174 -81 c12 -19 14 -31 7 -42 -7 -12 -6 -24 2 -40 15 -29 7 -59 -17 -73 -11 -5 -54 -9 -97 -7 l-77 3 -3 69 c-4 101 9 116 98 116 64 0 71 -2 87 -26z" />
      <path d="M134 223 c-16 -17 -18 -56 -4 -84 8 -14 21 -19 54 -19 23 0 46 3 49 7 12 11 -14 33 -39 33 -17 0 -24 6 -24 20 0 16 7 20 31 20 24 0 30 4 27 18 -4 22 -73 26 -94 5z" />
    </g>
  </svg>
);

const NewIcon = ({ isActive, style }) => (
  <span
    style={style || {}}
  >
    <svg width="32" height="22" viewBox="0 0 32 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30.6209 8.59856L5.97892 0.409455C5.65215 0.300861 5.29557 0.326689 4.98762 0.481258C4.67967 0.635827 4.44558 0.906474 4.33685 1.23366L1.05705 11.103C0.948316 11.4301 0.973847 11.7871 1.12802 12.0952C1.2822 12.4034 1.5524 12.6375 1.87917 12.7461L26.5211 20.9352C26.8479 21.0438 27.2045 21.0179 27.5124 20.8634C27.8204 20.7088 28.0544 20.4382 28.1632 20.111L31.443 10.2417C31.5517 9.91449 31.5262 9.55757 31.372 9.24942C31.2178 8.94128 30.9476 8.70716 30.6209 8.59856ZM11.0976 12.3848L9.55743 11.873L8.73422 8.17464L8.56947 7.22945L7.27805 11.1155L5.79953 10.6241L7.84941 4.45583L9.38953 4.96765L10.2127 8.66598L10.3159 9.5907L10.3775 9.61117C10.3775 9.61117 10.5619 8.8505 10.6439 8.60377L11.6073 5.70467L13.1474 6.21649L11.0976 12.3848ZM16.7036 14.2478L11.96 12.6714L14.0099 6.50311L18.6919 8.05904L18.2819 9.2927L15.14 8.24859L14.7711 9.35888L17.4817 10.2597L17.0717 11.4933L14.3611 10.5925L13.9306 11.8879L17.1341 12.9525L16.7036 14.2478ZM23.4185 16.4793L21.8784 15.9675L22.2463 12.802C22.2871 12.2676 22.3893 11.5481 22.3893 11.5481C22.3893 11.5481 22.0406 12.1857 21.8151 12.6587L20.1535 15.3943L18.6749 14.9029L18.9999 8.1614L20.54 8.67322L20.2951 11.4686C20.2618 12.0205 20.1925 12.5698 20.0897 13.1132L20.8897 11.7351L22.3878 9.2877 23.4407 9.7583 23.3017 14.1778 17.7 12.4185 16.4785 16.4793Z"
        fill={isActive ? "#D92D20" : "#A9A9"}
      />
    </svg>
  </span>
);

const FirstDesign = ({ ActiveButton, setActiveButton, t, translationPath, pullToHubType }) => {
  return (
    <div className="Active-btt-menu pt-3 d-flex justify-content-between">
      <ButtonBase
        className={`menu-button ${ActiveButton === 1 ? "is-active" : ""}`}
        onClick={() => setActiveButton(1)}
        style={{
          padding: "10px 20px",
          border: ActiveButton === 1 ? "2px solid #2193B1" : "2px dashed #2193B1",
          borderRadius: "8px",
          background: ActiveButton === 1 ? "#e6f0fa" : "transparent",
          marginRight: "10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "45%",
        }}
        disabled={pullToHubType === "Convolo"}
      >
        <HubSpotIcon />
        <span style={{ color: "#000", fontWeight: "bold", marginTop: "10px", fontSize: "19px" }}>
          {t(`${translationPath}Already existing`)}
        </span>
        
      </ButtonBase>
      <ButtonBase
        className={`menu-button ${ActiveButton === 2 ? "is-active" : ""}`}
        onClick={() => setActiveButton(2)}
        style={{
          padding: "10px 20px",
          border: ActiveButton === 2 ? "2px solid #2193B1" : "2px dashed #2193B1",
          borderRadius: "8px",
          background: ActiveButton === 2 ? "#e6f0fa" : "transparent",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "45%",
          position: "relative",
        }}
        disabled={pullToHubType === "Convolo"}
      >
        <NewIcon
          isActive={ActiveButton === 2}
          style={{
            position: "absolute",
            top: "5px",
            right: "56px",
          }}
        />
        <HubSpotIcon />
        <span style={{ color: "#000", fontWeight: "bold", marginTop: "10px", fontSize: "19px" }}>
          {t(`${translationPath}NewList`)}
        </span>
        
      </ButtonBase>
    </div>
  );
};

const ScanedDesign = ({ ActiveButton, setActiveButton, t, translationPath }) => {
  return (
    <div className="Active-btt-menu pt-3 d-flex justify-content-center">
      <ButtonBase
        className={`menu-button ${ActiveButton === 1 ? "is-active" : ""}`}
        onClick={() => setActiveButton(1)}
        style={{
          padding: "10px 20px",
          border: ActiveButton === 1 ? "2px solid #2193B1" : "2px dashed #2193B1",
          borderRadius: "8px",
          background: ActiveButton === 1 ? "#e6f0fa" : "transparent",
          marginRight: "10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "45%",
        }}
      >
        <BrightCallIcon />
        <span style={{ color: "#000", fontWeight: "bold", marginTop: "10px", fontSize: "19px" }}>
          {t(`${translationPath}Already existing`)}
        </span>
        
      </ButtonBase>
      <ButtonBase
        className={`menu-button ${ActiveButton === 2 ? "is-active" : ""}`}
        onClick={() => setActiveButton(2)}
        style={{
          padding: "10px 20px",
          border: ActiveButton === 2 ? "2px solid #2153B1" : "2px dashed #2153B1",
          borderRadius: "8px",
          background: ActiveButton === 2 ? "#e6f0fa" : "transparent",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "45%",
          position: "relative",
        }}
      >
        <NewIcon
          isActive
          style={{
            position: "absolute",
            top: "3px",
            right: "87px",
          }}
        />
        <BrightCallIcon />
        <span style={{ color: "#000", fontWeight: "bold", marginTop: "10px", fontSize: "19px" }}>
          {t(`${translationPath}New project`)}
        </span>
 
      </ButtonBase>
    </div>
  );
};
export const HubspotComponentView = ({
  parentTranslationPath,
  translationPath,
  isOpen,
  onClose,
  state,
  createHubSpotJson,
  totalCount,
  pullToHubType,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [isLoading, setIsLoading] = useState({
    importContacts: false,
    allProjects: false,
    saveName: false,
  });
  const [isMissingInfoMSGOpen, setIsMissingInfoMSGOpen] = useState(false);
  const [allProjects, setAllProjects] = useState({
    projects: [],
    totalCount: 0,
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [helperText, setHelperText] = useState({
    name: "",
  });

  const [selected, setSelected] = useState({
    project: null,
  });
  const [listNameInfo, setListNameInfo] = useState({
    listName: null,
  });

  const [ActiveButton, setActiveButton] = useState(1);

  const [importContactsState, setImportContactsState] = useState({
    listId: null,
    projectId: null,
    projectName: null,
    pageIndex: 1,
    pageSize: totalCount || 10,
  });

  const [nameInfo, setNameInfo] = useState({
    name: null,
  });

  const schema = Joi.object({
    ...(pullToHubType === "Hubspot"
      ? {
        listId: Joi.number()
          .required()
          .messages({
            "number.base": t(`${translationPath}hubspot-list-is-required`),
            "number.empty": t(`${translationPath}hubspot-empty-is-required`),
            "number.required": t(`${translationPath}hubspot-list-is-required`),
          }),
      }
      : {
        projectId: Joi.number()
          .required()
          .messages({
            "number.base": t(`${translationPath}convolo-project-is-required`),
            "number.empty": t(`${translationPath}convolo-project-is-required`),
            "number.required": t(`${translationPath}convolo-project-is-required`),
          }),
      }),
  })
    .options({
      abortEarly: false,
      allowUnknown: true,
    })
    .validate(importContactsState);

  const GetAllProjects = useCallback(async () => {
    setIsLoading((item) => ({ ...item, allProjects: true }));
    const apiCall = pullToHubType === "Convolo" ? GetAllConvoloProjects : GetAllHubSpotListsAPI;
    const res = await apiCall();
    if (!(res && res.status && res.status !== 200)) {
      const projects = pullToHubType === "Convolo" ? res?.projects : res?.lists || [];
      setAllProjects({
        projects,
        totalCount: projects?.length || 0,
      });
    } else {
      setAllProjects({
        projects: [],
        totalCount: 0,
      });
    }
    setIsLoading((item) => ({ ...item, allProjects: false }));
  }, [pullToHubType]);

  const saveListNameHandler = useCallback(async () => {
    if (!nameInfo.name) {
      showError(t(`${translationPath}new-list-name-required`));
      setHelperText((item) => ({ ...item, name: t(`${translationPath}new-list-name-required`) }));
      return;
    }
    setIsLoading((item) => ({ ...item, saveName: true }));
    const res = await CreateHubSpotListAPI(nameInfo.name);
    setIsLoading((item) => ({ ...item, saveName: false }));
    if (res && !res.Message) {
      showSuccess(t(`${translationPath}add-new-list-in-hubspot-successfully`));
      setSelected((item) => ({ ...item, project: res }));
      setImportContactsState((item) => ({
        ...item,
        listId: res.listId,
      }));
      setActiveButton(1);
      setTimeout(() => {
        GetAllProjects();
        setSelected((item) => ({ ...item, project: res }));
        setImportContactsState((item) => ({
          ...item,
          listId: res.listId,
        }));
      }, 2000);
    } else {
      const messageOne =
        res?.Message?.includes("List_Name_Exist") ? "list-name-exist" : null;
      showError(
        messageOne
          ? t(`${translationPath}${messageOne}`)
          : t(`${translationPath}add-new-list-in-hubspot-failed`)
      );
      setHelperText((item) => ({
        ...item,
        name: messageOne ? t(`${translationPath}${messageOne}`) : "",
      }));
    }
  }, [nameInfo, t, translationPath]);

  const saveListNameAndPullHandler = useCallback(async () => {
    if (!nameInfo.name) {
      showError(t(`${translationPath}new-list-name-required`));
      setHelperText((item) => ({ ...item, name: t(`${translationPath}new-list-name-required`) }));
      return;
    }
    setIsLoading((item) => ({ ...item, saveName: true }));
    const res = await CreateHubSpotListAPI(nameInfo.name);
    setIsLoading((item) => ({ ...item, saveName: false }));
    if (res && !res.Message) {
      showSuccess(t(`${translationPath}add-new-list-in-hubspot-successfully`));
      setImportContactsState((item) => ({
        ...item,
        listId: res.listId,
      }));
      setIsLoading((item) => ({ ...item, importContacts: true }));
      const pullRes = await ImportContactsAPI(
        {
          listId: res.listId,
          pageIndex: importContactsState.pageIndex || 1,
          pageSize: importContactsState.pageSize || totalCount || 10,
        },
        {
          spName: "GetSegmentationContacts",
          reportJson: { ...createHubSpotJson },
          systemReportCategoryTypeId: null,
          reportId: null,
          systemReportName: null,
        }
      );
      setIsLoading((item) => ({ ...item, importContacts: false }));
      if (!(pullRes && pullRes.status && pullRes.status !== 200)) {
        showSuccess(t(`${translationPath}the-background-pull-process-that-is-running`));
        setIsMissingInfoMSGOpen(true);
      } else {
        showError(t(`${translationPath}pull-contacts-to-hubspot-failed`));
      }
    } else {
      const messageOne =
        res?.Message?.includes("List_Name_Exist") ? "list-name-exist" : null;
      showError(
        messageOne
          ? t(`${translationPath}${messageOne}`)
          : t(`${translationPath}add-new-list-in-hubspot-failed`)
      );
      setHelperText((item) => ({
        ...item,
        name: messageOne ? t(`${translationPath}${messageOne}`) : "",
      }));
    }
  }, [nameInfo, t, translationPath, createHubSpotJson, importContactsState, totalCount]);

  const saveProjectNameAndPullHandler = useCallback(async () => {
    if (!nameInfo.name) {
      showError(t(`${translationPath}new-project-name-required`));
      setHelperText((item) => ({ ...item, name: t(`${translationPath}new-project-name-required`) }));
      return;
    }
    setIsLoading((item) => ({ ...item, saveName: true }));
    const res = await CreateConvoloProject(encodeURIComponent(nameInfo.name));
    setIsLoading((item) => ({ ...item, saveName: false }));
    if (res && res?.status !== 500) {
      showSuccess(t(`${translationPath}add-new-project-in-convolo-successfully`));
      const newProjectId = res.id;
      const newProjectName = res.name;
      if (!newProjectId || !newProjectName) {
        showError(t(`${translationPath}invalid-project-creation-response`));
        return;
      }
      setImportContactsState((item) => ({
        ...item,
        projectId: newProjectId,
        projectName: newProjectName,
      }));
      setIsLoading((item) => ({ ...item, importContacts: true }));
      const pullParams = {
        projectId: newProjectId,
        projectName: newProjectName,
        pageIndex: importContactsState.pageIndex || 1,
        pageSize: importContactsState.pageSize || totalCount || 10,
      };
      const pullBody = {
        spName: "GetSegmentationContacts",
        reportJson: { ...createHubSpotJson },
        systemReportCategoryTypeId: 0,
        reportId: 0,
        systemReportName: null,
      };
      const pullRes = await PullContactsToConvolo(
        { params: pullParams },
        pullBody
      );
      setIsLoading((item) => ({ ...item, importContacts: false }));
      if (!(pullRes && pullRes.status && pullRes.status !== 200)) {
        showSuccess(t(`${translationPath}the-background-pull-process-that-is-running`));
        setIsMissingInfoMSGOpen(true);
      } else {
        showError(t(`${translationPath}pull-contacts-to-convolo-failed`));
      }
    } else {
      const messageOne =
        res?.Message?.includes("Project_Name_Exist") ? "project-name-exist" : null;
      showError(
        messageOne
          ? t(`${translationPath}${messageOne}`)
          : t(`${translationPath}add-new-project-in-convolo-failed`)
      );
      setHelperText((item) => ({
        ...item,
        name: messageOne ? t(`${translationPath}${messageOne}`) : "",
      }));
    }
  }, [nameInfo, t, translationPath, createHubSpotJson, importContactsState, totalCount]);

  const saveHandler = useCallback(async () => {
    if (pullToHubType === "Hubspot" && !importContactsState.listId) {
      showError(t(`${translationPath}hubspot-list-is-required`));
      return;
    }
    if (pullToHubType === "Convolo" && !importContactsState.projectId) {
      showError(t(`${translationPath}convolo-project-is-required`));
      return;
    }
    setIsLoading((item) => ({ ...item, importContacts: true }));
    const pullApiCall = pullToHubType === "Convolo" ? PullContactsToConvolo : ImportContactsAPI;
    const pullParams = pullToHubType === "Convolo"
      ? {
        projectId: importContactsState.projectId,
        projectName: importContactsState.projectName || "",
        pageIndex: importContactsState.pageIndex || 1,
        pageSize: importContactsState.pageSize || totalCount || 10,
      }
      : {
        listId: importContactsState.listId,
        pageIndex: importContactsState.pageIndex || 1,
        pageSize: importContactsState.pageSize || totalCount || 10,
      };
    const pullBody = {
      spName: "GetSegmentationContacts",
      reportJson: { ...createHubSpotJson },
      systemReportCategoryTypeId: null,
      reportId: null,
      systemReportName: null,
    };
    const res = await pullApiCall(
      pullToHubType === "Convolo"
        ? { params: pullParams }
        : pullParams,
      pullBody
    );
    setIsLoading((item) => ({ ...item, importContacts: false }));
    if (!(res && res.status && res.status !== 200)) {
      showSuccess(t(`${translationPath}the-background-pull-process-that-is-running`));
      setIsMissingInfoMSGOpen(true);
    } else {
      showError(
        t(
          `${translationPath}pull-contacts-to-${pullToHubType === "Convolo" ? "convolo" : "hubspot"
          }-failed`
        )
      );
    }
  }, [createHubSpotJson, importContactsState, t, translationPath, pullToHubType, totalCount]);

  useEffect(() => {
    GetAllProjects();
  }, [GetAllProjects]);

  useEffect(() => {
    if (!isOpen) {
      setImportContactsState({
        listId: null,
        projectId: null,
        projectName: null,
        pageIndex: 1,
        pageSize: totalCount || 10,
      });
      setNameInfo({
        name: null,
      });
      setHelperText({
        name: "",
      });
      setSelected({
        project: null,
      });
      setActiveButton(1);
    }
  }, [isOpen, totalCount]);

  return (
    <>
      <DialogComponent
        saveText={t(
          `${translationPath}${ActiveButton === 2
            ? "create-and-pull-contacts"
            : `pull-contacts-to-${pullToHubType.toLowerCase()}`
          }`
        )}
        disableBackdropClick
        titleText={t(`${translationPath}pull-contact-to-${pullToHubType.toLowerCase()}`)}
        saveClasses="btns theme-solid bg-primary"
        saveType="button"
        maxWidth="sm"
        dialogContent={
          <div className="d-flex-column-center">
            <Spinner isActive={isLoading.importContacts || isLoading.saveName} isAbsolute />
            <div className="w-100">
              {pullToHubType === "Hubspot" && (
                <FirstDesign
                  ActiveButton={ActiveButton}
                  setActiveButton={setActiveButton}
                  t={t}
                  translationPath={translationPath}
                  pullToHubType={pullToHubType}
                />
              )}
              {pullToHubType === "Convolo" && (
                <ScanedDesign
                  ActiveButton={ActiveButton}
                  setActiveButton={setActiveButton}
                  t={t}
                  translationPath={translationPath}
                />
              )}
            </div>
            <div className="w-100 mr-1-reversed mt-3">
              {ActiveButton === 1 && (
                <AutocompleteComponent
                  idRef="allProjects"
                  className="px-2"
                  selectedValues={selected.project}
                  labelValue={t(
                    `${translationPath}${pullToHubType === "Convolo" ? "convolo-project" : "hub-spot-list"
                    }`
                  )}
                  data={allProjects.projects || []}
                  multiple={false}
                  displayLabel={(option) => (option && (option.projectName || option.name)) || ""}
                  chipsLabel={(option) => (option && (option.projectName || option.name)) || ""}
                  withoutSearchButton
                  isDisabled={false}
                  onChange={(event, newValue) => {
                    setSelected((item) => ({ ...item, project: newValue }));
                    setImportContactsState((item) => ({
                      ...item,
                      listId: pullToHubType === "Hubspot" ? (newValue && newValue.listId) || null : null,
                      projectId: pullToHubType === "Convolo" ? (newValue && newValue.id) || null : null,
                      projectName: pullToHubType === "Convolo" ? (newValue && newValue.name) || null : null,
                    }));
                  }}
                  isLoading={isLoading.allProjects}
                  withLoader
                />
              )}
              {ActiveButton === 2 && (
                <Inputs
                  idRef="nameRef"
                  labelValue={t(
                    `${translationPath}new-${pullToHubType === "Convolo" ? "project" : "list"
                    }-name`
                  )}
                  value={nameInfo.name || ""}
                  helperText={helperText.name}
                  error={isSubmitted && !nameInfo.name}
                  isWithError
                  isSubmitted={isSubmitted}
                  onInputChanged={(e) => {
                    const value = e?.target?.value || "";
                    setNameInfo((item) => ({ ...item, name: value }));
                    setHelperText((item) => ({ ...item, name: "" }));
                  }}
                  isDisabled={false}
                />
              )}
            </div>
          </div>
        }
        isOpen={isOpen}
        saveIsDisabled={
          isLoading.importContacts ||
          isLoading.allProjects ||
          isLoading.saveName ||
          (ActiveButton === 1 &&
            (pullToHubType === "Hubspot" ? importContactsState.listId === null : importContactsState.projectId === null)) ||
          (ActiveButton === 2 && (!nameInfo.name || nameInfo.name.trim() === ""))
        }
        onSaveClicked={() => {
          setIsSubmitted(true);
          if (ActiveButton === 2 && nameInfo.name) {
            if (pullToHubType === "Hubspot") {
              saveListNameAndPullHandler();
            } else {
              saveProjectNameAndPullHandler();
            }
          } else if (ActiveButton === 1 && (importContactsState.listId || importContactsState.projectId)) {
            saveHandler();
          } else if (ActiveButton === 2 && nameInfo.name && pullToHubType === "Hubspot") {
            saveListNameHandler();
          }
        }}
        onCancelClicked={onClose}
        translationPath={translationPath}
        onCloseClicked={onClose}
      />
      {isMissingInfoMSGOpen && (
        <MessageConfirmDialog
          isDialogOpen={isMissingInfoMSGOpen}
          theme="warning"
          content={{
            heading: `pull-contacts-to-${pullToHubType.toLowerCase()}`,
            body: t(
              `${translationPath}in-background-pull-process-that-is-running-please-check-your-process-to-complete-and-wait-new-notification-soon`
            ),
          }}
          confirmButton={{
            label: t(`${translationPath}confirm`),
            handler: () => {
              onClose();
              setIsMissingInfoMSGOpen(false);
            },
          }}
          cancelButton={{
            label: t(`${translationPath}discard`),
            handler: () => {
              onClose();
              setIsMissingInfoMSGOpen(false);
            },
          }}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
        />
      )}
    </>
  );
};